import { render } from "./FurtherReading.vue?vue&type=template&id=23568fbd&scoped=true"
import script from "./FurtherReading.vue?vue&type=script&lang=js"
export * from "./FurtherReading.vue?vue&type=script&lang=js"

import "./FurtherReading.vue?vue&type=style&index=0&id=23568fbd&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23568fbd"]])

export default __exports__